import { useEffect } from "react";
import { Contact } from "@/components/Contact";

export default function ContactPage() {
  useEffect(() => {
    document.title = "Contact & Support — ORIVA AI";
  }, []);

  return (
    <main className="pt-16" data-testid="contact-page">
      <Contact />
    </main>
  );
}
